import {
  Factory, Building2, ShoppingBag, HeartPulse, Cog, Hotel, Truck, Landmark, Cpu, UtensilsCrossed,
  Scale, Palette, Newspaper, GraduationCap, Ruler, Sparkle, Dumbbell, PartyPopper, Sun, Sprout,
  Car, Coins, Users, Wallet,
} from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

const ICONS = {
  oil_gas: Factory,
  construction: Building2,
  retail: ShoppingBag,
  healthcare: HeartPulse,
  manufacturing: Cog,
  hospitality: Hotel,
  logistics: Truck,
  financial: Landmark,
  ict: Cpu,
  fnb: UtensilsCrossed,
  professional_services: Scale,
  creative_agencies: Palette,
  media: Newspaper,
  education: GraduationCap,
  architecture: Ruler,
  beauty_wellness: Sparkle,
  fitness: Dumbbell,
  events: PartyPopper,
  renewables: Sun,
  agritech: Sprout,
  automotive: Car,
  fintech: Coins,
  hrtech: Users,
  family_office: Wallet,
};

const ORDER = [
  "oil_gas", "construction", "retail", "healthcare", "manufacturing", "hospitality",
  "logistics", "financial", "ict", "fnb",
  "professional_services", "creative_agencies", "media", "education", "architecture",
  "beauty_wellness", "fitness", "events", "renewables", "agritech", "automotive",
  "fintech", "hrtech", "family_office",
];

export default function Industries({ onPickIndustry }) {
  const { t } = useLang();
  return (
    <section id="industries" className="section-pad bg-cb-paper">
      <div className="container-cb">
        <div className="max-w-3xl">
          <div className="overline mb-4 flex items-center gap-3">
            <span className="gold-divider" /> {t.industries.overline}
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-cb-primary">{t.industries.title}</h2>
          <p className="mt-4 text-cb-secondary text-base lg:text-lg">{t.industries.sub}</p>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3">
          {ORDER.map((id, idx) => {
            const Icon = ICONS[id];
            return (
              <button
                key={id}
                onClick={() => onPickIndustry && onPickIndustry(id)}
                data-testid={`industry-card-${id}`}
                className="card-cb text-start p-4 group"
                style={{ animationDelay: `${idx * 25}ms` }}
              >
                <div className="w-9 h-9 rounded-lg bg-cb-accent-surface grid place-items-center text-cb-emerald group-hover:bg-cb-emerald group-hover:text-white transition-colors">
                  <Icon size={18} />
                </div>
                <div className="mt-3 text-cb-primary font-medium text-sm leading-snug" style={{ fontFamily: "Outfit" }}>
                  {t.industriesList[id]}
                </div>
                <div className="mt-1 text-[10px] text-cb-secondary uppercase tracking-widest">#{String(idx + 1).padStart(2, "0")}</div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
